<div
class="slds-tabs_scoped__content {{ isOpen ? 'slds-show' : 'slds-hide' }}"
      role="tabpanel"
    >
    <ng-content></ng-content>
</div>
